// extracted by mini-css-extract-plugin
export default {"component":"QuickPresentationAddComponent_component__i9DpZ","explaining":"QuickPresentationAddComponent_explaining__IZSI+"};